import React, { Component } from 'react';
import { connect } from 'react-redux';
import './ServiceProviders.css';
import SimpleTable from 'components/shared/table/SimpleTable';
import Input from 'components/shared/input/Input';
import Button from 'components/shared/button/Button';
import { Row, Col } from 'react-bootstrap';
import ContractorStatus from 'components/admin/contractors/ContractorStatus';
import {
  loadServiceProviders,
  setServiceProviderDropdown,
  changePage,
  setNameToSearch,
  clearFilters,
  setCompanyData,
  goToNewServiceProvider,
} from 'components/admin/service-providers/store/actions';

import {
  getServiceProviders,
  getServiceProvidersCurrentPage,
  getServiceProvidersTotal,
  getServiceProvidersPageSize,
  getServiceProvidersDropdown,
  getServiceProviderNameToSearch,
} from 'components/admin/service-providers/store/selectors';

import { simpleScrollToTop } from 'services/utils/scroller-util';
import SimplePagination from 'components/shared/pagination/SimplePagination';
import Dropdown from 'components/shared/dropdown/Dropdown';
import {
  ServiceProviderTypes,
  ServiceProviderOptions,
} from 'domain/service-provider-type-enum';
import { ServiceProviderValuesToUrl } from 'domain/service-provider-type-enum';

class ServiceProviders extends Component {
  handleServiceProviderDropdownChange = (option) => {
    const { dispatch } = this.props;
    dispatch(setServiceProviderDropdown(option.value));
    dispatch(loadServiceProviders(option.value));
  };

  componentDidMount() {
    this.props.dispatch(
      loadServiceProviders(this.props.serviceProvidersDropdown)
    );
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(clearFilters());
  }

  componentDidUpdate() {
    simpleScrollToTop();
  }

  inviteServiceProviderButtonLabel = () => {
    const { serviceProvidersDropdown } = this.props;
    return `Invite ${
      ServiceProviderTypes[serviceProvidersDropdown] || 'Service Provider'
    }`;
  };

  handleServiceProviderSelection = (index) => {
    simpleScrollToTop();
    const { history, serviceProvidersDropdown, serviceProviders } = this.props;
    const serviceProviderId = serviceProviders[index].id;
    const serviceProviderValue = ServiceProviderValuesToUrl.get(
      serviceProvidersDropdown
    );
    history.push(
      `/admin/service-providers/${serviceProviderValue}/${serviceProviderId}`
    );
  };

  handleServiceProvidersPageChange = (newPage) => {
    const {
      serviceProvidersDropdown,
      serviceProviderNameToSearch,
      dispatch,
    } = this.props;
    dispatch(changePage(newPage));
    dispatch(
      loadServiceProviders(
        serviceProvidersDropdown,
        serviceProviderNameToSearch,
        newPage
      )
    );
  };

  handleInputNameChange = (value) => {
    const { dispatch, serviceProvidersDropdown } = this.props;
    dispatch(setNameToSearch(value));
    dispatch(loadServiceProviders(serviceProvidersDropdown, value));
  };

  handleInviteServiceProvider = () => {
    const { serviceProvidersDropdown, dispatch } = this.props;
    const serviceProviderValue = ServiceProviderValuesToUrl.get(
      serviceProvidersDropdown
    );
    dispatch(setCompanyData({}));
    dispatch(goToNewServiceProvider(serviceProviderValue));
  };

  handleGenerateLink = (index) => {
    const { serviceProvidersDropdown, serviceProviders } = this.props;
    const serviceProviderId = serviceProviders[index].id;
    const serviceProviderValue = ServiceProviderValuesToUrl.get(
      serviceProvidersDropdown
    );
    return `service-providers/${serviceProviderValue}/${serviceProviderId}`;
  };

  render() {
    return (
      <div className="service-providers">
        <div className="full-title">Service Providers</div>

        <div className="content-container">
          <Row className="filter-container">
            <Col sm={4}>
              <Dropdown
                className="positive-negative-drop-down"
                options={ServiceProviderOptions.filter(
                  (spType) =>
                    spType.label !== 'Client' &&
                    spType.label !== 'Subcontractor'
                )}
                placeholder="Service Provider Options"
                value={this.props.serviceProvidersDropdown}
                onChange={this.handleServiceProviderDropdownChange}
              />
            </Col>
            <Col sm={4}>
              <Input
                className="input-name"
                onChange={this.handleInputNameChange}
                value={this.props.serviceProviderNameToSearch}
                theme="normal"
                placeholder="Search by Name"
              />
            </Col>
            <Col sm={4}>
              <div className="buttons-container">
                <Button
                  className="button-orange"
                  label={this.inviteServiceProviderButtonLabel()}
                  onClick={this.handleInviteServiceProvider}
                />
              </div>
            </Col>
          </Row>

          <SimpleTable
            className="service-providers-table"
            headers={['COMPANY NAME', 'STATUS', 'POC', 'EMAIL']}
            rows={this.mapServiceProviders(this.props.serviceProviders)}
            emptyMessage="No Companies"
            onRowSelected={this.handleServiceProviderSelection}
            onGenerateLink={this.handleGenerateLink}
          />

          <div className="pagination-container">
            <SimplePagination
              currentPage={this.props.serviceProvidersCurrentPage}
              pageSize={this.props.serviceProvidersPageSize}
              total={this.props.serviceProvidersTotal}
              onPageChange={this.handleServiceProvidersPageChange}
            />
          </div>
        </div>
      </div>
    );
  }

  mapServiceProviders = (serviceProviders) => {
    return serviceProviders.map((serviceProvider) => {
      return [
        <span className="h4">{serviceProvider.name}</span>,
        <ContractorStatus status={serviceProvider.status} />,
        serviceProvider.contact !== null
          ? `${serviceProvider.contact.first_name} ${serviceProvider.contact.last_name}`
          : 'N/A',
        serviceProvider.contact !== null
          ? serviceProvider.contact.email
          : 'N/A',
      ];
    });
  };
}

export default connect((state) => {
  return {
    serviceProviders: getServiceProviders(state),
    serviceProvidersCurrentPage: getServiceProvidersCurrentPage(state),
    serviceProvidersPageSize: getServiceProvidersPageSize(state),
    serviceProvidersDropdown: getServiceProvidersDropdown(state),
    serviceProvidersTotal: getServiceProvidersTotal(state),
    serviceProviderNameToSearch: getServiceProviderNameToSearch(state),
  };
})(ServiceProviders);



// WEBPACK FOOTER //
// ./src/components/admin/service-providers/ServiceProviders.js